export default __webpack_public_path__ + "static/media/greenscreen4.46bfc90c.jpg";